import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';
import { FileUploadModule } from 'ng2-file-upload';
import { NgxSkeletonLoaderModule } from '@exalif/ngx-skeleton-loader';
//import { SkeletonLoaderDashboardComponent } from './skeleton-loader-dashboard/skeleton-loader-dashboard.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { PortfolioSummaryListComponent } from './portfolio-summary-list/portfolio-summary-list.component';
import { PinInputComponent } from './pin-input/pin-input.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { RecentTrxHistoryComponent } from './recent-trx-history/recent-trx-history.component';
import { RecentTrxHistoryListComponent } from './recent-trx-history-list/recent-trx-history-list.component';
import { AccountsCardCarouselComponent } from './accounts-card-carousel/accounts-card-carousel.component';
import { AccountCardComponent } from './account-card/account-card.component';
import { HTabBarComponent } from './h-tab-bar/h-tab-bar.component';
import { PhoneNumberComponent } from './phone-number/phone-number.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ImageCropperUploadComponent } from './image-cropper-upload/image-cropper-upload.component';
import { MobileNumberComponent } from './mobile-number/mobile-number.component';
import { FlexPayChartComponent } from './flex-pay-chart/flex-pay-chart.component';
import { FlexPayTrxComponent } from './flex-pay-trx/flex-pay-trx.component';
import { CurrenyFormatterPipe } from '../pipes/curreny-formatter.pipe';
import { NgxPopperModule } from 'ngx-popper';
import { DateFormatterPipe } from '../pipes/date-formatter.pipe';
import { AccountsDropdownComponent } from './accounts-dropdown/accounts-dropdown.component';
import { AmountFieldComponent } from './amount-field/amount-field.component';
import { ChunkPipe } from "../pipes/chunk.pipe";
import { TwoDecimalDirective } from "../pipes/two-decimal.directive";
import { RecentTrxHistoryCoverComponent } from './recent-trx-history-cover/recent-trx-history-cover.component';
import { GreenifyProgressBarComponent } from './greenify-progress-bar/greenify-progress-bar.component';
import { TrxListDetailComponent } from './trx-list-detail/trx-list-detail.component';
import { PipesModule } from '../pipes/pipes.module';
import { ConfirmationAlertComponent } from '../confirmation-alert/confirmation-alert.component';
import { ParseInnerHtml } from '../InnerHtmlPipe';
import { LoanTrxListDetailComponent } from './loan-trx-list-detail/loan-trx-list-detail.component';
import { LoanDetailsComponent } from './loan-details/loan-details.component';
import { LoansDropdownComponent } from './loans-dropdown/loans-dropdown.component';
import { DepositSummaryCardComponent } from './deposit-summary-card/deposit-summary-card.component';
import { DepositDetailsComponent } from './deposit-details/deposit-details.component';
import { LoansTrxCoverComponent } from './loans-trx-cover/loans-trx-cover.component';
import { LoansOverviewComponent } from './loans-overview/loans-overview.component';
import { LoanDetailsCardComponent } from './loan-details-card/loan-details-card.component';
import { LoanInformationComponent } from './loan-information/loan-information.component';
import { TrxDepositsOverviewCardComponent } from './trx-deposits-overview-card/trx-deposits-overview-card.component';
import { DepositsTrxCoverComponent } from './deposits-trx-cover/deposits-trx-cover.component';
import { TrxDepositsOverviewComponent } from './trx-deposits-overview/trx-deposits-overview.component';
import { TrxDepositsHistoryComponent } from './trx-deposits-history/trx-deposits-history.component';
import { TrxDepositDetailsComponent } from './trx-deposit-details/trx-deposit-details.component';
import { LoanDisbursalsComponent } from '../retail/transactions/loans/loan-disbursals/loan-disbursals.component';
import { LoanDisbursalCardComponent } from '../retail/transactions/loans/loan-disbursal-card/loan-disbursal-card.component';
import { LoanDisbursalIndicatorComponent } from '../retail/transactions/loans/loan-disbursal-indicator/loan-disbursal-indicator.component';
import { LoanTrxHistoryComponent } from '../retail/transactions/loans/loan-trx-history/loan-trx-history.component';
import { ChequesHistoryComponent } from '../common/components/cheques-history/cheques-history.component';
import { ChequeListComponent } from './cheque-list/cheque-list.component';
import { TranslateModule } from '@ngx-translate/core';
import { YouHaveYouOwnComponent } from '../common/components/you-have-you-own/you-have-you-own.component';
import { MutualfundTrxCoverComponent } from './mutualfund-trx-cover/mutualfund-trx-cover.component';
import { MutualfundDetailsComponent } from './mutualfund-details/mutualfund-details.component';
//import { FooterComponent } from '../footer/footer.component';
import { ServiceRequestComponent } from './service-request/service-request.component';
import { ServiceRequestHistoryComponent } from '../common/components/service-request-history/service-request-history.component';
import { NotificationListComponent } from './notification-list/notification-list.component';
import { AdsBannerComponent } from '../common/components/ads-banner/ads-banner.component';
import { TrxLoansHistoryComponent } from './trx-loans-history/trx-loans-history.component';
import { TrxLoanDetailsComponent } from './trx-loan-details/trx-loan-details.component';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = {}

@NgModule({
  declarations: [
   // SkeletonLoaderDashboardComponent,
    PortfolioSummaryListComponent,
    PinInputComponent,
    RecentTrxHistoryComponent,
    RecentTrxHistoryListComponent,
    AccountsCardCarouselComponent,
    AccountCardComponent,
    HTabBarComponent,
    PhoneNumberComponent,
    ProgressBarComponent,
    ImageCropperUploadComponent,
    MobileNumberComponent,
    FlexPayChartComponent,
    FlexPayTrxComponent,
    DateFormatterPipe,
    AccountsDropdownComponent,
    AmountFieldComponent,
    ChunkPipe,
    TwoDecimalDirective,
    RecentTrxHistoryCoverComponent,
    GreenifyProgressBarComponent,
    TrxListDetailComponent,
    ConfirmationAlertComponent,
    CurrenyFormatterPipe,
    ParseInnerHtml,
    LoanTrxListDetailComponent,
    LoanDetailsComponent,
    LoansDropdownComponent,
    DepositSummaryCardComponent,
    DepositDetailsComponent,
    LoansTrxCoverComponent,
    LoansOverviewComponent,
    LoanDetailsCardComponent,
    LoanInformationComponent,
    TrxDepositsOverviewCardComponent,
    DepositsTrxCoverComponent,
    TrxDepositsOverviewComponent,
    TrxDepositsHistoryComponent,
    TrxDepositDetailsComponent,
    LoanDisbursalsComponent,
    LoanDisbursalCardComponent,
    LoanDisbursalIndicatorComponent,
    LoanTrxHistoryComponent,
    ChequesHistoryComponent,
    ChequeListComponent,
    YouHaveYouOwnComponent,
    MutualfundTrxCoverComponent,
    MutualfundDetailsComponent,
    //FooterComponent,
    ServiceRequestHistoryComponent,
    ServiceRequestComponent,
    NotificationListComponent,
    AdsBannerComponent,
    TrxLoansHistoryComponent,
    TrxLoanDetailsComponent
  ],
  imports: [
    CommonModule,
    NgxSkeletonLoaderModule,
    FormsModule,
    FileUploadModule,
    MatAutocompleteModule,
    NgOtpInputModule,
    SlickCarouselModule,
    ImageCropperModule,
    TranslateModule,
    NgxPopperModule.forRoot({}),
    PipesModule
  ],
  exports: [
   // FooterComponent,
    //SkeletonLoaderDashboardComponent,
    PortfolioSummaryListComponent,
    PinInputComponent,
    RecentTrxHistoryComponent,
    RecentTrxHistoryListComponent,
    AccountsCardCarouselComponent,
    AccountCardComponent,
    HTabBarComponent,
    PhoneNumberComponent,
    ProgressBarComponent,
    ImageCropperUploadComponent,
    FlexPayChartComponent,
    FlexPayTrxComponent,
    NgxPopperModule,
    DateFormatterPipe,
    AccountsDropdownComponent,
    AmountFieldComponent,
    ChunkPipe,
    TwoDecimalDirective,
    RecentTrxHistoryCoverComponent,
    GreenifyProgressBarComponent,
    ConfirmationAlertComponent,
    CurrenyFormatterPipe,
    ParseInnerHtml,
    LoanDetailsComponent,
    LoansDropdownComponent,
    LoansTrxCoverComponent,
    TrxDepositsOverviewCardComponent,
    DepositsTrxCoverComponent,
    TrxDepositsOverviewComponent,
    TrxDepositsHistoryComponent,
    LoanDisbursalsComponent,
    LoanDisbursalCardComponent,
    LoanDisbursalIndicatorComponent,
    LoanTrxHistoryComponent,
    ChequesHistoryComponent,
    ChequeListComponent,
    YouHaveYouOwnComponent,
    MutualfundTrxCoverComponent,
    MutualfundDetailsComponent,
    ServiceRequestHistoryComponent,
    ServiceRequestComponent,
    NotificationListComponent,
    AdsBannerComponent,
    TrxLoansHistoryComponent,
    TrxLoanDetailsComponent
  ],
  providers: [CurrenyFormatterPipe],
})
export class DashboardModule { }
